import { SeequentLogo } from '@local/login/dist/assets/SeequentLogo';
import {
    LOGIN_SIDEBAR_DOWNLOADS,
    LOGIN_SIDEBAR_DOWNLOADS_BLURB,
    LOGIN_SIDEBAR_DOWNLOADS_LINK,
    LOGIN_SIDEBAR_TRAINING_AND_SUPPORT,
    LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_LINK,
    LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_TITLE,
} from '@local/login/dist/strings';
import { useTrace } from '@local/web-design-system/dist/utils/trace';
import Grid from '@mui/material/GridLegacy';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { useStyles } from './LoginSideBar.styles';

type LoginSideBarProps = {
    trainingLink?: string;
};

type SideBarLinkData = {
    preLinkedText: string;
    linkedText: string;
    href: string;
};

const SideBarLinkSection = ({
    title,
    blurb,
    link,
    traceId,
}: {
    title: string;
    blurb: string;
    link: SideBarLinkData;
    traceId: string;
}) => {
    const applyTrace = useTrace('loginSideBar');
    return (
        <>
            <Typography variant="h1">{title}</Typography>
            <Typography variant="body2">{blurb}</Typography>
            <Typography variant="body2" paddingTop={1}>
                <span key={link.preLinkedText}>
                    {link.preLinkedText}
                    <Link
                        href={link.href}
                        target="_blank"
                        color="inherit"
                        rel="noopener"
                        underline="always"
                        {...applyTrace(traceId)}
                    >
                        {link.linkedText}
                    </Link>
                    <br />
                </span>
            </Typography>
        </>
    );
};

export const LoginSideBar = ({ trainingLink }: LoginSideBarProps) => {
    const { classes } = useStyles();

    return (
        <Grid container className={classes.root}>
            <Grid className={classes.logo}>
                <SeequentLogo />
            </Grid>
            <Grid className={classes.body} container direction="column" data-dd-privacy="allow">
                <SideBarLinkSection
                    title={LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_TITLE}
                    blurb={LOGIN_SIDEBAR_TRAINING_AND_SUPPORT}
                    link={{
                        ...LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_LINK,
                        href: trainingLink ?? LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_LINK.href,
                    }}
                    traceId="help-support-link"
                />
                <SideBarLinkSection
                    title={LOGIN_SIDEBAR_DOWNLOADS}
                    blurb={LOGIN_SIDEBAR_DOWNLOADS_BLURB}
                    link={LOGIN_SIDEBAR_DOWNLOADS_LINK}
                    traceId="downloads-link"
                />
            </Grid>
        </Grid>
    );
};
